import { type FC } from "react";
import { type AddressButtonProps } from "./types";
import { HouseNumberButton } from "./house-number-button";
import { EditHouseNumberButton } from "./edit-house-number";

export const MinusTwoButton: FC<AddressButtonProps> = (props) => (
  <HouseNumberButton {...props} offset={-2} label="-2" />
);

export const MinusOneButton: FC<AddressButtonProps> = (props) => (
  <HouseNumberButton {...props} offset={-1} label="-1" />
);

export const PlusOneButton: FC<AddressButtonProps> = (props) => (
  <HouseNumberButton {...props} offset={1} label="+1" />
);

export const PlusTwoButton: FC<AddressButtonProps> = (props) => (
  <HouseNumberButton {...props} offset={2} label="+2" />
);

export const HouseNumberButtonGroup: FC<AddressButtonProps> = (props) => (
  <div className="flex items-center space-x-1">
    <MinusTwoButton {...props} />
    <MinusOneButton {...props} />
    <PlusOneButton {...props} />
    <PlusTwoButton {...props} />
    <EditHouseNumberButton {...props} />
  </div>
);
